import { FdsIconType } from '@tcc/fds';
import { FeatureAsset } from '../../types/assets';
import { ImpersonationMode } from '../../types/impersonationModes';
import { UserRole } from '../../types/user';

export enum NavigationItemType {
  LINK = 'link',
  MENU = 'menu',
}
export interface LinkDescriptor {
  id?: string;
  label: string;
  href: string;
  testId?: string;
  queryParams?: Record<string, string>;
  allowedRoles?: UserRole[];
  excludedRoles?: UserRole[];
  allowedCountryCodes?: string[];
  excludedCountryCodes?: string[];
  allowedFeatureAssets?: FeatureAsset[];
  requiredFeatureFlags?: string[];
  excludedByFeatureFlag?: string[];
  allowedImpersonationModes?: ImpersonationMode[];
  excludedImpersonationModes?: ImpersonationMode[];
  isActiveRegexs?: RegExp[];
  leadingIcon?: FdsIconType;
  trailingIcon?: FdsIconType;
  activity?: boolean;
  notificationBadge?: string;
  order?: number;
  canAccess?: boolean;
  target?: string;
  title?: string;
}

export interface MenuDescriptor {
  id: string,
  label: string;
  leadingIcon?: FdsIconType;
  trailingIcon?: FdsIconType;
  links: LinkDescriptor[];
  order?: number;
}

export enum UrlPlaceholders {
  ROOT_URL = '{{ROOT_URL}}',
  QUERY_PARAMS = '{{QUERY_PARAMS}}',
  EXPERTO_URL = 'https://experto.climate.com',
  SUPPORT_URL = 'https://support.agent.tcc.li'
}
export type DeferredLinkDescriptor = LinkDescriptor & { canAccess: boolean };

export interface NavigationLink {
  id?: string;
  label: string;
  href: string;
  testId?: string;
  isActive: boolean;
  order?: number;
}
export interface NavigationMenu {
  id: string,
  label: string;
  leadingIcon?: FdsIconType;
  trailingIcon?: FdsIconType;
  links: NavigationLink[];
  order?: number;
}

export interface NavigationItem {
  id?: string;
  type: NavigationItemType;
  order?: number;
  data: NavigationLink | NavigationMenu | undefined;
}

